var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 81"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M30.5 11.766a1 1 0 0 1 1-1h38a1 1 0 0 1 1 1v58a1 1 0 0 1-1 1h-38a1 1 0 0 1-1-1v-15a1 1 0 1 1 2 0v14h36v-56h-36v14a1 1 0 0 1-2 0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M37.694 25.852a1 1 0 0 1 1.076.171l14.4 13a1 1 0 0 1 0 1.485l-14.4 13a1 1 0 0 1-1.67-.742v-6.8H10.5a1 1 0 0 1-1-1v-10.4a1 1 0 0 1 1-1h26.6v-6.8a1 1 0 0 1 .594-.914m1.406 3.164v5.55a1 1 0 0 1-1 1H11.5v8.4h26.6a1 1 0 0 1 1 1v5.55l11.908-10.75z",
    clipRule: "evenodd"
  })));
};
export default SvgLogout;